module.exports = __webpack_public_path__ + "img/prize-sm-light.cb2e1a25.png";